import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/flex/")({
	beforeLoad: () => {
		throw redirect({ to: "/partner" });
	},
});
